export const AwsConfig = {
  region: process.env.REACT_APP_AWS_REGION,
  userPoolId: process.env.REACT_APP_AWS_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_CLIENT_ID,
}
